import React from 'react';
import { Phone, Settings, Home } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const Header: React.FC = () => {
  const navigate = useNavigate();

  return (
    <header className="bg-white shadow-lg sticky top-0 z-50">
      <div className="container-custom">
        <div className="flex justify-between items-center py-4">
          <div className="flex items-center space-x-4">
            <h1 className="text-2xl font-bold text-primary-600">VendaMotos Honda</h1>
            <span className="hidden sm:block text-sm text-secondary-600">Motos populares com melhor preço</span>
          </div>
          <div className="flex items-center space-x-4">
            <button
              onClick={() => navigate('/')}
              className="flex items-center space-x-2 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg transition-colors duration-200"
            >
              <Home size={20} />
              <span className="hidden sm:block">Início</span>
            </button>
            <button
              onClick={() => navigate('/admin/login')}
              className="flex items-center space-x-2 bg-gray-600 hover:bg-gray-700 text-white px-4 py-2 rounded-lg transition-colors duration-200"
            >
              <Settings size={20} />
              <span className="hidden sm:block">Admin</span>
            </button>
            <a href="https://wa.me/5513996763208" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-2 bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg transition-colors duration-200">
              <Phone size={20} />
              <span className="hidden sm:block">(13) 99676-3208</span>
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};